import React from "react";
import { purifyHtml } from "utils/functions/purifyUtil";

interface SafeHtmlProps {
  /** Publisher supplied HTML. It is always sanitized before rendering. */
  html: string;
  className?: string;
  /** Wrapper element to render. Defaults to a `div` for block-safe rich content. */
  as?: React.ElementType;
}

/**
 * Centralizes publisher-supplied HTML rendering for offer and reward content.
 * Content is sanitized with the strict offerwall policy in `purifyUtil`.
 */
const SafeHtml = ({ html, className, as: Tag = "div" }: SafeHtmlProps) => (
  <Tag className={className} dangerouslySetInnerHTML={{ __html: purifyHtml(html ?? "") }} />
);

export default SafeHtml;
